import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React from 'react';

import Button from 'components/basic/Button';
import { H4 } from 'components/basic/Typography';
import s from 'components/pagesComponents/payments/PaymentSuccessPage/PaymentSuccessPage.module.scss';

import type { PaymentSystemType } from 'redux-store/slices/purchases/types';

export default function TwicePaymentInstructionsLink({
  paymentSystem,
  className,
}: {
  paymentSystem: PaymentSystemType;
  className?: string;
}): JSX.Element {
  const t = useTranslationAndTypograph();

  let storeName = 'apple';

  if (paymentSystem === 2) {
    storeName = 'google';
  }

  return (
    <div className={className}>
      <H4 className={s.cancelPaymentH4} dangerouslySetInnerHTML={{ __html: t("Cancel your old subscription,<br/> so you don't get billed twice") }} />
      <div className={cn(s.buttonWrapper, 'mt-6')}>
        <Button
          onClick={(): void => {
            logEvent('Web_Payment_Success_Page_Button_Clicked', {
              button_id: 'instructions',
            });
          }}
          className={s.button}
          href={`/payments/cancel-store-subscription/${storeName}/`}
          look="secondary"
        >
          {t('See instructions')}
        </Button>
      </div>
    </div>
  );
}
